<template>
  <div class="container">
    <register-head></register-head>

    <fade-transition :duration="200" origin="center top" mode="out-in">
      <div>
        <register-form formHeader="ข้อมูลเบื้องต้น">
          <div class="row mt-1">
            <div class="col-12">
              <h6>รหัสนักศึกษา {{ getKmuttId }}</h6>
            </div>
          </div>

          <!-- Upload Image --->
          <div class="row mt-2">
            <div class="col-3">
              <!--              <img src="img/Eng60yr.png" class="img-thumbnail">-->
              <file-pond
                name="formImage"
                ref="formImage"
                class-name="my-pond"
                label-idle="Click or Drop files here..."
                maxFileSize="1MB"
                :allow-multiple="false"
                accepted-file-types="image/jpeg, image/png"
                v-model="form.display"
                class="mt-3"
                :style="isEmailFormat ? `` : `border-color: #A72C32`"
              />
            </div>
            <div class="col-8">
              <h5 class="mt-3">รูปประจำตัว</h5>
              <p class="mb-2">
                (อัพโหลดรูปประจำตัว เพื่อเพิ่มโอกาสในการรับเข้าสัมภาษณ์)
              </p>
              <!--              <a class="btn btn-secondary btn-user btn-sm" href="#">Choose File</a>-->
              <p class="my-2">.JPEG, .PNG ขนาดไฟล์ไม่เกิน 1MB</p>
            </div>
          </div>

          <div class="form-group row mt-3">
            <div class="col-sm-2 mb-3 mb-sm-0">
              <label for="prefix_th" class="font-weight-normal"
              >คำนำหน้าชื่อ</label
              >
              <select
                class="form-control round"
                id="prefix_th"
                style="border-radius: 10rem;"
                v-model="form.prefix"
              >
                <option disabled value="">คำนำหน้าชื่อ</option>
                <option value="male">นาย</option>
                <option value="female">นางสาว</option>
              </select>
            </div>
            <div class="col-sm-5 mb-3 mb-sm-0 ">
              <label for="inputName_th" class="font-weight-normal"
              >ชื่อ (ภาษาไทย)</label
              >
              <input
                type="text"
                class="form-control form-control-user "
                id="inputName_th"
                placeholder="ชื่อ"
                style="padding: 1.2rem 1rem;"
                v-model="form.firstName.th"
              />
            </div>
            <div class="col-sm-5 ">
              <label for="inputSurname_th" class="font-weight-normal"
              >นามสกุล (ภาษาไทย)</label
              >
              <input
                type="text"
                class="form-control form-control-user "
                id="inputSurname_th"
                placeholder="นามสกุล"
                style="padding: 1.2rem 1rem;"
                v-model="form.lastName.th"
              />
            </div>
          </div>

          <div class="form-group row mt-3">
            <div class="col-sm-2 mb-3 mb-sm-0">
              <label for="prefix_en" class="font-weight-normal"
              >คำนำหน้าชื่อ</label
              >
              <select
                class="form-control round"
                id="prefix_en"
                style="border-radius: 10rem;"
                v-model="form.prefix"
              >
                <option disabled value="">Prefix</option>
                <option value="male">Mr.</option>
                <option value="female">Miss</option>
              </select>
            </div>
            <div class="col-sm-5 mb-3 mb-sm-0 ">
              <label for="inputName_en" class="font-weight-normal"
              >ชื่อ (ภาษาอังกฤษ)</label
              >
              <input
                type="text"
                class="form-control form-control-user "
                id="inputName_en"
                placeholder="First Name"
                style="padding: 1.2rem 1rem;"
                v-model="form.firstName.en"
              />
            </div>
            <div class="col-sm-5 ">
              <label for="inputSurname_en" class="font-weight-normal"
              >นามสกุล (ภาษาอังกฤษ)</label
              >
              <input
                type="text"
                class="form-control form-control-user "
                id="inputSurname_en"
                placeholder="Last name"
                style="padding: 1.2rem 1rem;"
                v-model="form.lastName.en"
              />
            </div>
          </div>

          <div class="form-group row mt-4">
            <div class="col-sm-6 mb-3 mb-sm-0 ">
              <label for="phoneInput" class="font-weight-bold"
              >โทรศัพท์มือถือ (ที่สามารถติดต่อได้)</label
              >
              <input
                type="phone"
                class="form-control form-control-user "
                id="phoneInput"
                placeholder="08x-xxx-xxxx"
                style="padding: 1.2rem 1rem;"
                v-model="form.phone"
                @keyup="checkPhone(form.phone)"
                :style="isPhoneFormat ? `` : `border-color: #A72C32`"
              />
            </div>
            <div class="col-sm-6 mb-3 mb-sm-0 ">
              <label for="emailStudent" class="font-weight-bold"
              >E-mail (ที่สามารถติดต่อได้)</label
              >
              <input
                type="email"
                class="form-control form-control-user "
                id="emailStudent"
                placeholder="example@example.com"
                @keydown="checkEmail(form.email)"
                style="padding: 1.2rem 1rem;"
                v-model="form.email"
                :style="isEmailFormat ? `` : `border-color: #A72C32`"
              />
            </div>
          </div>

          <div class="form-group row">
            <div class="col-12 font-weight-normal mb-3 mb-sm-0 ">
              <label for="inputCurriculum" class="font-weight-normal"
              >หลักสูตร</label
              >
              <select
                class="form-control round"
                id="inputCurriculum"
                style="border-radius: 10rem;"
                v-model="form.faculty"
              >
                <option disabled value="">หลักสูตร</option>
                <template v-for="(faculty, id) in faculties">
                  <option :value="[id, faculty]" :key="`$faculty ${id}`">{{
                    faculty
                    }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </register-form>
      </div>
    </fade-transition>

    <div class="col-12 offset-sm-1 col-sm-10 user pb-5">
      <div class="row text-center">
        <hr class="col-10"/>
      </div>
      <div class="row my-3 d-flex justify-content-center">
        <div class="col-4">
          <button
            class="btn btn-secondary user btn-user btn-block"
            @click="checkForm"
          >
            Register
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import registerHead from "@/components/forms/registerHead";
    import registerForm from "@/components/forms/registerForm";

    // Import Vue FilePond
    import vueFilePond from "vue-filepond";

    // Import FilePond styles
    import "filepond/dist/filepond.min.css";

    // Import FilePond plugins
    // Please note that you need to install these plugins separately

    // Import image preview plugin styles
    import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

    // Import imagane preview d file type validation plugins
    import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
    import FilePondPluginImagePreview from "filepond-plugin-image-preview";
    import {mapGetters} from "vuex";
    import api from "@/services/api";

    const FilePond = vueFilePond(
        FilePondPluginFileValidateType,
        FilePondPluginImagePreview
    );

    export default {
        name: "register",
        components: {
            registerHead,
            registerForm,
            FilePond
        },
      beforeMount() {
        this.chcekData();
      },
      computed: {
        ...mapGetters(["getKmuttId", "getKmuttToken"])
        },
        data() {
            return {
                form: {
                    display: [],
                    prefix: "",
                    firstName: {
                        th: "",
                        en: ""
                    },
                    lastName: {
                        th: "",
                        en: ""
                    },
                    phone: "",
                    email: "",
                    faculty: []
                },
                isEmailFormat: true,
                isPhoneFormat: true,
                faculties: [
                    "วศ.บ. วิศวกรรมการผลิตชิ้นส่วนยานยนต์",
                    "วท.บ. วิทยาศาสตร์ข้อมูลสุขภาพ",
                    "วศ.บ. วิศวกรรมคอมพิวเตอร์",
                    "วศ.บ. วิศวกรรมคอมพิวเตอร์ (หลักสูตรนานาชาติ)",
                    "วศ.บ. วิศวกรรมเคมี ",
                    "วศ.บ. วิศวกรรมเคมี (หลักสูตรนานาชาติ)",
                    "วศ.บ. วิศวกรรมเครื่องกล",
                    "วศ.บ. วิศวกรรมเครื่องกลและพลังงาน",
                    "วศ.บ. วิศวกรรมเครื่องมือ",
                    "วศ.บ. วิศวกรรมไฟฟ้า",
                    "วศ.บ. วิศวกรรมไฟฟ้า (ระบบไฟฟ้า อิเล็กทรอนิกส์ และพลังงาน)",
                    "วศ.บ. วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์",
                    "วศ.บ. วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์ (หลักสูตรนานาชาติ)",
                    "วศ.บ. วิศวกรรมเมคคาทรอนิกส์",
                    "วศ.บ. วิศวกรรมยานยนต์",
                    "วศ.บ. วิศวกรรมโยธา",
                    "วศ.บ. วิศวกรรมโยธา (หลักสูตรนานาชาติ)",
                    "วศ.บ. วิศวกรรมระบบควบคุมและเครื่องมือวัด",
                    "วศ.บ. วิศวกรรมวัสดุ",
                    "วศ.บ. วิศวกรรมสิ่งแวดล้อม",
                    "วศ.บ. วิศวกรรมสิ่งแวดล้อม (หลักสูตรนานาชาติ)",
                    "วศ.บ. วิศวกรรมอัตโนมัติ (หลักสูตรนานาชาติ) ",
                    "วศ.บ. วิศวกรรมอุตสาหการ"
                ]
            };
        },
        methods: {
            checkEmail(email) {
                let re = new RegExp(
                    // eslint-disable-next-line no-useless-escape
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
                this.isEmailFormat = re.test(email);
                return this.isEmailFormat;
            },
            checkForm() {
                let fieldValue = 0;

                if (this.form.prefix) {
                    fieldValue++;
                }
                if (this.form.email && this.isEmailFormat) {
                    fieldValue++;
                }
                if (this.form.firstName.th && this.form.firstName.en) {
                    fieldValue++;
                }
                if (this.form.lastName.th && this.form.lastName.en) {
                    fieldValue++;
                }
                if (this.form.phone && this.isPhoneFormat) {
                    fieldValue++;
                }
                if (this.form.faculty) {
                    fieldValue++;
                }
                if (fieldValue !== 6) {
                    alert("กรุณากรอกข้อมูลให้ครบ และถูกทุกช่อง");
                } else {
                    this.onSubmit();
                }
            },
            checkPhone(phone) {
                let re = new RegExp(
                    /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
                )

                if (re.test(phone)) {
                    let match = phone.match(/^(\d{3})(\d{3})(\d{4})$/);
                    if (match) {
                        this.form.phone = match[1] + '-' + match[2] + '-' + match[3]
                    }
                }
                this.isPhoneFormat = re.test(phone);
                return re.test(phone)
            },
            async onSubmit() {
                alert("onSubmit");
              let formData = new FormData();
              // let resume = new File(
              //   [this.$refs.formResume.getFiles()[0].file],
              //   "display.png"
              // );
              let image = new File(
                [this.$refs.formImage.getFiles()[0].file],
                "display.png"
              );
              let register_form = {
                title: this.form.prefix === "male" ? "Mr" : "Miss",
                firstName: this.form.firstName,
                lastName: this.form.lastName,
                phone: this.form.phone,
                email: this.form.email,
                faculty: this.form.faculty[1]
              };

              // formData.append("resume", resume);
              await formData.append("image", image);
              await formData.append("register_form", JSON.stringify(register_form));

              // let register_form = {

              // };
              await api.sendKmuttDetail(this.getKmuttToken, formData)
                .catch(err => {
                  console.log(err.data)
                })
            },
            async chcekData() {
              await api.getKmuttDetail(this.getKmuttToken)
                .catch(err => {
                  console.log(err.data)
                })
            }
        }
    };
</script>

<style scoped></style>
